export const setLogin = () => {
  return {
    type: 'SET_LOGIN',
    route: 'LOGIN',
    tab: 'EMAIL'
  }
}

export const setToken = (email) => {
  return {
    type: 'SET_TOKEN',
    route: 'LOGIN',
    tab: 'TOKEN',
    data: {
      email: email
    }
  }
}

export const setConsent = () => {
  return {
    type: 'SET_CONSENT',
    route: 'CONSENT',
    tab: null,
  }
}


// WEBPACK FOOTER //
// ./src/actions/layout.js